import { CommunicationDirection, EmailMessageDto, TicketMessage } from "@shared/models";
import {TicketNote} from "@pages/tickets/models/ticket-note";
import {FeedOwnerType} from "@pages/tickets/models/feed-detail-display-item";

export interface TicketFeed {
    id?: string;
    patientId?: number;
    contactId?: string;
    belongsToTicket?: string;
    belongsToTicketId?: string;
    ticketId?: number;
    createdBy?: string;
    createdByName?: string;
    modifiedBy?: string;
    createdOn?: Date;
    modifiedOn?: Date;
    feedType: FeedTypes;
    description?: string;
    ticketMessage?: EmailMessageDto | TicketMessage,
    isRelatedTicketFeed?: boolean;
    callDuration?: number;
    chatLink?: string;
    communicationDirection?: CommunicationDirection;
    voiceLink?: string;
    isAnonymousFeed?: boolean;
    isAgentFeed?: boolean;
    isPatientFeed?: boolean;
    isContactFeed?: boolean;
}

export enum FeedTypes {
    Sms = 1,
    Email,
    StatusChange,
    Note,
    Phone,
    PhoneCall,
    ChatActiviy,
    Other
}


export const getTicketFeedOwner = (feed: TicketFeed): FeedOwnerType => {
    if(feed.isAnonymousFeed) return 'anonymous';
    if(feed.isPatientFeed) return 'patient';
    if(feed.isAgentFeed) return 'agent';
    if(feed.isContactFeed) return 'contact';
    return 'anonymous';
};

